var locale = {
  locale: 'uz_UZ',
  today: 'Bugun',
  now: 'Hozir',
  backToToday: 'Bugunga qaytish',
  ok: 'OK',
  clear: 'Toza',
  month: 'Oy',
  year: 'Yil',
  timeSelect: 'vaqtni tanlang',
  dateSelect: 'sanani tanlang',
  weekSelect: 'Haftani tanlang',
  monthSelect: 'Oyni tanlang',
  yearSelect: 'Yilni tanlang',
  decadeSelect: 'O\'n yilni tanlang',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Oldingi oy (PageUp)',
  nextMonth: 'Keyingi oy (PageDown)',
  previousYear: 'O\'tgan yili (Control + left)',
  nextYear: 'Keyingi yil (Control + right)',
  previousDecade: 'Oxirgi o\'n yil',
  nextDecade: 'Keyingi o\'n yil',
  previousCentury: 'O\'tgan asr',
  nextCentury: 'Keyingi asr'
};
export default locale;